import {
  Box,
  Button,
  CircularProgress,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { XTERIO_CLAIM_END_DATE } from 'components/Notifications/Notifications';
import { commify, formatWithPrecision } from 'core/utils';
import useAirdrops from 'hooks/useAirdrops';
import { Fragment } from 'react';
import Countdown from 'react-countdown';

import ClaimCells from './ClaimCells';

export function ClaimsTable() {
  const { airdropsInfo: tokenRows, isLoading } = useAirdrops();

  return (
    <>
      <Table sx={{ display: { xs: 'none', sm: 'table' } }}>
        <TableHead>
          <TableRow>
            <TableCell>Token</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Status</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={99}>
                <Stack
                  alignItems="center"
                  direction="row"
                  justifyContent="center"
                  sx={{ fontWeight: 900 }}
                >
                  {isLoading ? <CircularProgress /> : 'You do not have any claimable rewards'}
                </Stack>
              </TableCell>
            </TableRow>
          ) : (
            <>
              {Date.now() < XTERIO_CLAIM_END_DATE.getTime() && (
                <>
                  <TableRow
                    sx={{
                      borderBottom: '1px solid #2027230F',
                    }}
                  />
                  <TableRow>
                    <TableCell>
                      <Stack alignItems="center" direction="row" gap={1}>
                        <Box
                          component="img"
                          src={'/icons/iconXterio.svg'}
                          sx={{
                            width: 24,
                            marginRight: 0.5,
                          }}
                        />
                        XTER (Tranche 1)
                      </Stack>
                    </TableCell>
                    <TableCell>
                      Refer to{' '}
                      <Link
                        component="a"
                        href="https://app.xter.io/dashboard/stake"
                        rel="noopener noreferrer"
                        sx={{ '&:hover': { textDecoration: 'underline' } }}
                        target="_blank"
                      >
                        Xterio claim page
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Countdown
                        date={XTERIO_CLAIM_END_DATE}
                        renderer={({ completed, days, hours, minutes, seconds }) => {
                          const dayStr = days ? `${days}d` : '';
                          const hourStr = hours || days ? `${hours}h` : '';
                          const minStr = hours || days || minutes ? `${minutes}m` : '';
                          const secStr = `${seconds}s`;
                          const timeStr = [dayStr, hourStr, minStr, secStr].join(' ');

                          return completed ? 'Ended' : `Ends in: ${timeStr}`;
                        }}
                      />
                    </TableCell>
                    <TableCell align="right">
                      <Button
                        onClick={() => {
                          window.open(
                            'https://x.com/XterioGames/status/1915324633638986136',
                            '_blank'
                          );
                        }}
                        variant="contained"
                      >
                        Claim
                      </Button>
                    </TableCell>
                  </TableRow>
                </>
              )}
              {tokenRows
                ?.sort(
                  (a, b) =>
                    (b.config?.claimWindow?.start || 0) - (a.config?.claimWindow?.start || 0) // Sort by most recent airdrop first
                )
                ?.map(row => {
                  return (
                    <Fragment key={row?.id}>
                      <TableRow
                        sx={{
                          borderBottom: '1px solid #2027230F',
                        }}
                      />
                      <TableRow>
                        <TableCell>
                          <Stack alignItems="center" direction="row" gap={1}>
                            <Box
                              component="img"
                              src={row?.config?.iconUrl}
                              sx={{
                                width: 24,
                                marginRight: 0.5,
                              }}
                            />
                            {row?.config?.tokenName}
                          </Stack>
                        </TableCell>
                        <TableCell>
                          {!row?.amount
                            ? 'Not Eligible'
                            : commify(formatWithPrecision(BigInt(row?.amount || 0n)))}
                        </TableCell>
                        <ClaimCells tokenClaimData={row} />
                      </TableRow>
                    </Fragment>
                  );
                })}
            </>
          )}
        </TableBody>
      </Table>
    </>
  );
}
